<template>
  <div>

    <page-heading
    title="Real Estate Search Parcel Information"
    email="auditor@jeffersoncountyoh.com"
    phone="(740) 283-8511"
    class="bg-orange-4"
    ></page-heading>

  </div>
</template>

<script>
import axios from 'axios'
import PageHeading from '../../components/layout/PageHeading'

export default {
  components: {
    PageHeading
  },
  data() {
    return {}
  },
  mounted: function() {
    this.loadParcel()
  },
  methods: {
    loadParcel: function() {
      let local = this
      let id = this.$route.params.id
      let year = this.$route.params.year

      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/real/parcel/' + id + '/' + year,
          data: this.search,
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
        .then(function (response) {
          local.tagData = response.data[0]
        })
        .catch(function (error) {
          console.log("dog tag error: ", error)
        });
    }
  }
}
</script>

<style>
</style>
